import { PureComponent } from "react";

import { toServiceDate } from "../../utils/date";

import type { DateInputProps } from "@progress/kendo-react-dateinputs";

import "./DatePicker.scss";

export class CustomDateInput extends PureComponent<DateInputProps> {
  render() {
    const { value, placeholder, disabled, id, name, title, ariaLabel } = this.props;

    return (
      <input
        className="custom_date_input"
        type="text"
        value={value ? toServiceDate(value) : ""}
        placeholder={placeholder ?? undefined}
        disabled={disabled}
        id={id ?? undefined}
        name={name ?? undefined}
        title={title ?? undefined}
        aria-label={ariaLabel ?? undefined}
        style={{ pointerEvents: "none" }}
        tabIndex={-1}
        readOnly
      />
    );
  }
}
